<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-checkbox v-model="show_non_active" label="Pokaż nieaktywnych"></v-checkbox>
      </v-col>
    </v-row>
    <v-layout row wrap>      
      <v-flex xs12>
        <v-data-table              
              :options.sync="pagination"
              :items="items"
              :loading="loading"              
              :server-items-length="totalResults"
              :no-results-text="'Nie znaleziono wierszy'"
              :footer-props="{itemsPerPageOptions:[20,50,100,200]}" 
              :no-data-text="'Brak danych'"
              :headers="headers">
               <template v-slot:item.color="{item}">
                  <div :style="'background-color: '+item.color+'; width: 100%; height: 20px;'"></div>      
               </template>
               <template v-slot:item.id={item}>
                  <v-layout align-center>
                      <v-icon small class="mr-2" @click="editTherapist(item.id)" title="Edytuj" v-if="$can('do','POKO_Terapeuci_Edycja')">fa-edit</v-icon>                      
                      </v-layout>
               </template>
            <template v-slot:item.isActive={item}>
              <v-layout align-center>
               {{item.isActive ? 'TAK' : 'NIE'}}
              </v-layout>
            </template>
        </v-data-table>          
      </v-flex>
    </v-layout>           
    <EditTherapist v-if="showEditTherapist" :groups="therapistGroups" :medical_chambers="medical_chambers" :medial_professions="medical_professions" :organizational_units="organizational_units" :visible="showEditTherapist" :id="selectedTherapistId" @close="closeAddPopup"/>

  </v-container>  
</template>

<script>
import {  mapActions } from "vuex";
import { therapistsService } from "@/services/";


import EditTherapist from "./EditTherapist";
import {settingsService} from "@/services";
import {slownikiService} from "@/services/slowniki.service";
export default {
  name: "Therapists",
  data() {
    return {
      loading: true,
      showEditTherapist: false,
      selectedTherapistId: 0,
      totalResults: 0,
      items: [],      
      pagination: {},
      show_non_active: false,
      headers: [
        { text: '', sortable: false, align: 'left', value: 'color'},
        { text: 'Imię', sortable: false, align: 'left', value: 'name'},
        { text: 'Nazwisko', sortable: false, align: 'left', value: 'surname'},
        { text: 'Telefon', sortable: false, align: 'left', value: 'phone'},
        { text: 'Aktywny użytkownik', sortable: false, align: 'left', value: 'isActive'},
        { text: 'Akcje', sortable: false, align: 'left', value: 'id'}

      ],
      organizational_units: [],
      medical_professions: [],
      medical_chambers: [],
      therapistGroups: []
    }
  },
  components: { EditTherapist },
  mounted() {
    
  },
  methods: {
    ...mapActions("title", ["updateTitle"]),
    ...mapActions("alert", ["error", "success"]),  
    async fetchGroups() {
      this.loading = true;
      try {
        var result = await therapistsService.getTherapistGroups();        
        this.therapistGroups = result.data.result;
      } catch (error) {
        console.error('Błąd podczas pobierania grup');
      } finally {
        this.loading = false;
      }
    },
    editTherapist(id) {
     this.selectedTherapistId = id
     this.showEditTherapist = true
    },
    closeAddPopup() {
      this.showEditTherapist = false
      this.selectedTherapistId  = 0
      this.refreshTable()
    },
    refreshTable()
    {
          this.loading = true

          this.requestTherapists().then(data=> {
            this.items = data.data.result.items,
            this.totalResults = data.data.result.totalCount
            this.loading = false
          })    
    },    
    requestTherapists() {
      const {   page, itemsPerPage } = this.pagination                                                
      var req = therapistsService.getAll({ query: '', page: page, limit: itemsPerPage, IsActive: (this.show_non_active ? false : true) });
      return req.catch(() => {
        this.error("Błąd pobierania terapeutów");
      });               
    },
    loadOrganizationalUnits() {
      this.loading = true
      settingsService.GetOrganizationalUnits(0).then((result) => {
        this.organizational_units = result.data.result
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getMedicalProfessions() {
      this.loading = true
      therapistsService.GetMedicalProfessions().then((result) => {
        this.medical_professions = result.data.result
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getMedicalChambers() {
      this.loading = true
      slownikiService.GetMedicalChambers().then((result) => {
        this.medical_chambers = result.data.result
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  },
  created() {
    this.updateTitle("Terapeuci");
    this.loadOrganizationalUnits()
    this.getMedicalProfessions()
    this.getMedicalChambers()
    this.fetchGroups()
  },
    watch: {
      pagination: {
        handler() {
          this.refreshTable()
        },
        deep: true
      },
      show_non_active: {
        handler() {
          this.refreshTable()
        }
      }
  },  
};
</script>

<style>


</style>
